/* Lunelle - Barre d'achat flottante (fiche produit)
   Reprise de la sticky-add-cart de the-foldie.com, structure et declenchement.

   DECLENCHEMENT, mesure sur leur page le 2026-08-14 : ce n'est PAS une
   profondeur de defilement en dur. Leur regle, decompilee :
     afficher quand le bloc des boutons d'achat est entierement passe AU-DESSUS
     du haut de l'ecran (bottom <= 0) ; masquer quand il redevient visible ;
     masquer aussi des que le pied de page arrive a moins de 100 px du bas.
   On reprend la regle telle quelle, ancree sur NOTRE bloc .product-form__buttons.
   Verification que la transposition tombe au bon endroit :
     Foldie  : bouton a 1472, declenchement a 1524, soit 14,2 % de la page
     Lunelle : bouton a 1291, declenchement a 1325, soit 13,1 % de la page
   Les deux pages ont des proportions quasi identiques, donc aucune correction
   n'est necessaire.

   TOUT EST PROXIFIE, RIEN N'EST REIMPLEMENTE. C'est le point important :
     - clic sur une pastille  -> clic sur le vrai label .swatch-anchor
     - clic sur - / +         -> clic sur les vrais boutons de quantity-input
     - clic sur Ajouter       -> clic sur le vrai .product__add-to-cart
   Le theme, l'appli globo et Kaching continuent donc de fonctionner exactement
   comme avant : changement de variante, mise a jour de la galerie et du prix,
   ouverture du tiroir, et surtout l'ajout automatique du 2e sac et de la gourde
   que Kaching declenche sur le chemin fiche produit. Reimplementer /cart/add
   aurait casse tout cela en silence.

   PASTILLES CLONEES DEPUIS LE DOM, pas rendues en Liquid : les visuels sont des
   background-image poses en style inline par l'appli globo, et la couleur est un
   metaobjet lie. Les recalculer en Liquid serait fragile ; les cloner garantit
   un rendu identique. On lit l'id de variante dans le for du label
   (swatch-detail-<variantId>-1-0) et l'etat coche sur l'input radio associe.

   Z-INDEX : volontairement SOUS le tiroir (2147483647) et sous le panneau de
   ventes croisees (2147483000), pour ne jamais recouvrir l'un ou l'autre. La
   barre se masque aussi quand l'un des deux est ouvert, pour ne pas afficher
   deux appels a l'action concurrents.

   PAS de backdrop-filter, volontairement : voir la chasse au gel desktop dans
   les notes du projet. Fond blanc opaque, cout GPU nul.
*/
(function () {
  if (window.__lunelleStickyAtc) return;
  window.__lunelleStickyAtc = true;

  var Z = 2147480000;
  var FOOTER_MARGIN = 100; /* comme Foldie */

  var CSS =
    '.lunelle-satc{position:fixed;left:12px;right:12px;bottom:12px;margin:0 auto;' +
    'max-width:520px;z-index:' + Z + ';background:#FFF;border:1px solid #E5E7EB;' +
    'border-radius:16px;box-shadow:0 6px 24px rgba(13,13,13,.14);padding:10px 12px;' +
    'opacity:0;transform:translateY(130%);transition:opacity .22s ease,transform .28s ease;' +
    'pointer-events:none;}' +
    '.lunelle-satc.is-shown{opacity:1;transform:translateY(0);pointer-events:auto;}' +
    /* Bloc identite (vignette + nom + prix) : DESKTOP UNIQUEMENT. Masque par
       defaut, il n'est reaffiche que dans la media query 750px tout en bas.
       C'est ce qui garantit que le mobile ne bouge pas malgre le DOM en plus. */
    '.lunelle-satc__id{display:none;}' +
    /* --per-row est pose par le JS (voir perRow()). La largeur maximale du bloc
       vaut EXACTEMENT une ligne pleine, ce qui force la coupure au bon endroit ;
       justify-content:center recentre alors la ligne courte sous la longue.
       Un grid aurait cale la 2e ligne a gauche au lieu de la centrer. */
    '.lunelle-satc__swatches{--sw:36px;--gap:8px;display:flex;flex-wrap:wrap;' +
    'justify-content:center;gap:var(--gap);margin:0 auto 9px;' +
    'max-width:calc(var(--per-row) * var(--sw) + (var(--per-row) - 1) * var(--gap));}' +
    '.lunelle-satc__sw{width:var(--sw);height:var(--sw);border-radius:50%;background-size:cover;' +
    'background-position:center;border:1px solid #D8D8D8;cursor:pointer;padding:0;' +
    'flex:0 0 auto;transition:box-shadow .15s ease,border-color .15s ease;}' +
    '.lunelle-satc__sw.is-active{border-color:#0D0D0D;box-shadow:0 0 0 2px #FFF inset,0 0 0 2px #0D0D0D;}' +
    '.lunelle-satc__sw.is-out{opacity:.35;cursor:not-allowed;}' +
    '.lunelle-satc__buy{display:flex;align-items:stretch;gap:8px;}' +
    '.lunelle-satc__qty{display:flex;align-items:center;gap:2px;border:1px solid #DCDCDC;' +
    'border-radius:10px;padding:0 4px;flex:0 0 auto;}' +
    '.lunelle-satc__qbtn{width:26px;height:36px;border:0;background:none;font-size:17px;' +
    'line-height:1;color:#0D0D0D;cursor:pointer;padding:0;}' +
    '.lunelle-satc__qbtn[disabled]{opacity:.3;cursor:default;}' +
    '.lunelle-satc__qval{min-width:18px;text-align:center;font-size:14px;font-weight:600;color:#0D0D0D;}' +
    '.lunelle-satc__add{flex:1 1 auto;min-height:44px;border:0;border-radius:10px;' +
    'background:#0D0D0D;color:#FFF;font-size:15px;font-weight:600;letter-spacing:.01em;' +
    'cursor:pointer;padding:0 12px;}' +
    '.lunelle-satc__add:disabled{opacity:.45;cursor:default;}' +
    /* Tailles. Historique du reglage : 28px au depart (trop petit pour
       reconnaitre le sac), puis 44px (juge trop gros), donc 36px, le milieu
       exact. Deux lignes de 36px donnent une barre d'environ 151px, tres
       proche des 156px de Foldie.
       Verification que la ligne pleine tient toujours, avec 6 par ligne
       (11 couleurs vendables -> 6 + 5) :
         ecran 375px -> barre 359, contenu 339 ; 6 x 36 + 5 x 8 = 256  OK
         ecran 361px -> contenu 325                                    OK
         ecran 320px -> contenu 284 ; d'ou la reduction a 32px sous 361px :
                        6 x 32 + 5 x 6 = 222                           OK
       Sans ce dernier palier, la ligne se coupait plus tot sur les petits
       ecrans et laissait une pastille seule en bas, ce qu'on veut eviter. */
    '@media (min-width:431px){.lunelle-satc__swatches{--sw:40px;}}' +
    '@media (max-width:430px){.lunelle-satc{left:8px;right:8px;padding:9px 10px;}' +
    '.lunelle-satc__add{font-size:14px;}}' +
    '@media (max-width:360px){.lunelle-satc__swatches{--sw:32px;--gap:6px;}}' +

    /* ------------------------------------------------------------------ *
       VUE DESKTOP ETENDUE (>= 750px), demandee le 2026-08-14.

       LE MOBILE NE DOIT PAS BOUGER D'UN PIXEL. D'ou deux garde-fous :
         - .lunelle-satc__id est en display:none par defaut et n'apparait que
           dans ce bloc ; sous 750px le DOM en plus ne rend donc rien ;
         - tout ce qui suit est enferme dans la media query, et ce bloc est
           place APRES celui de 431px pour que --sw:30px l'emporte sur --sw:40px
           (meme specificite, c'est la derniere regle qui gagne).

       Structure reprise de Foldie, mesuree sur leur page a 1440px :
         barre max-width 1120px, hauteur 154px, en flex
           [vignette 70px + nom + prix/badges]  [pastilles 2 lignes]  [achat]
       Leurs pastilles desktop font ~28px, donc PLUS PETITES que leurs pastilles
       mobile : sur une seule ligne horizontale, la place se partage. On fait
       pareil (30px contre 36px en mobile).

       Notre barre sera plus courte que leurs 154px : ils empilent un selecteur
       de quantite au-dessus du bouton, que nous n'avons pas (voir plus haut).
       On ne cherche pas a egaler leur hauteur pour la forme. */
    '@media (min-width:750px){' +
    '.lunelle-satc{max-width:1120px;left:24px;right:24px;bottom:20px;padding:14px 18px;' +
    'border-radius:18px;display:flex;align-items:center;gap:20px;}' +
    '.lunelle-satc__id{display:flex;align-items:center;gap:12px;flex:1 1 auto;min-width:0;}' +
    '.lunelle-satc__thumb{width:70px;height:70px;flex:0 0 auto;border:1px solid #E5E7EB;' +
    'border-radius:12px;background-size:cover;background-position:center;background-color:#F4F4F4;}' +
    '.lunelle-satc__meta{min-width:0;}' +
    '.lunelle-satc__name{display:block;font-size:15px;font-weight:600;line-height:1.25;' +
    'color:#0D0D0D;margin-bottom:6px;}' +
    /* Le bloc prix/badges est CLONE depuis .lunelle-offer__row de la fiche :
       meme prix, meme copie, meme style de marque, aucune duplication a
       maintenir. On autorise juste le retour a la ligne, la rangee d'origine
       etant reglee en nowrap pour la fiche produit. */
    /* .lunelle-offer porte un margin-top de 8px pour la fiche produit : on le
       neutralise ici. Meme specificite que la regle d'origine, mais notre
       feuille est injectee apres, donc c'est la notre qui gagne. */
    '.lunelle-satc__offer{margin:0;}' +
    '.lunelle-satc__offer .lunelle-offer__row{flex-wrap:wrap;margin:0;}' +
    /* PRIX DESANIME DANS LA BARRE. Sur la fiche, le prix est en 22px/600 et
       c'est tres bien : c'est l'element principal du bloc d'achat. Repris tel
       quel dans la barre, il faisait 47 % de plus que le nom du produit juste
       au-dessus et donnait un air de fausse promo. Foldie ne met AUCUN accent
       sur le prix dans sa barre : mesure le 2026-08-14, leur nom de produit,
       leur prix et leur mention LIMITED OFFER sont tous en 16px/500, strictement
       uniformes. On applique le meme principe : meme taille que le nom (15px) et
       une graisse plus legere (500 contre 600), donc le prix accompagne au lieu
       de crier.
       Le selecteur est volontairement double (.lunelle-satc__offer devant) :
       specificite 0,2,0 contre 0,1,0 pour la regle d'origine, donc le prix de la
       FICHE reste bien en 22px/600. Verifie apres coup. */
    '.lunelle-satc__offer .lunelle-offer__price{font-size:15px;font-weight:500;}' +
    '.lunelle-satc__swatches{margin:0;flex:0 0 auto;--sw:30px;--gap:6px;}' +
    '.lunelle-satc__buy{flex:0 0 auto;width:250px;}' +
    '}';

  function injectCss() {
    if (document.getElementById('lunelle-satc-css')) return;
    var s = document.createElement('style');
    s.id = 'lunelle-satc-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* --- references vers le vrai formulaire ------------------------------- */
  /* .product__add-to-cart n'existe QUE sur le bouton principal : les boutons
     des ventes croisees sont de simples .product-form__submit. */
  function realAdd() { return document.querySelector('.product__add-to-cart'); }
  function anchorEl() { var a = realAdd(); return a ? a.closest('.product-form__buttons') : null; }
  function realSwatches() { return document.querySelectorAll('label.swatch-anchor[for^="swatch-detail-"]'); }

  /* Quantite : SCOPEE au formulaire principal, jamais au document.
     Constat du 2026-08-14 : la fiche produit n'a AUCUN selecteur de quantite.
     Le seul <quantity-input> de la page est celui du TIROIR (Drawer-quantity-2),
     qui pilote une ligne du panier. Une recherche au niveau du document aurait
     fini par le proxifier, donc par modifier le panier depuis la fiche produit.
     Consequence assumee : la barre n'affiche pas de selecteur de quantite, la
     ou Foldie en a un. Si un jour le formulaire principal en recoit un, il sera
     repris automatiquement. */
  function mainForm() { var a = realAdd(); return a ? a.closest('form') : null; }
  function realQtyInput() { var f = mainForm(); return f ? f.querySelector('quantity-input input') : null; }
  function realQtyBtn(which) { var f = mainForm(); return f ? f.querySelector('quantity-input button[name="' + which + '"]') : null; }

  /* Nombre de pastilles par ligne. On ne laisse JAMAIS une ligne avec une seule
     pastille : on calcule d'abord le nombre de lignes necessaires (6 au maximum
     par ligne, la limite de place mesuree ci-dessus), puis on repartit a parts
     egales. L'ecart entre la ligne la plus longue et la plus courte reste donc
     de 1 au maximum.
       11 couleurs -> 2 lignes -> 6 + 5      (le cas actuel)
       12          -> 2 lignes -> 6 + 6
       13          -> 3 lignes -> 5 + 5 + 3
       7           -> 2 lignes -> 4 + 3
     Une simple coupure a 6 aurait donne 6 + 5 aujourd'hui mais 6 + 6 + 1 a 13
     couleurs, soit exactement la pastille orpheline a eviter. */
  function perRow(n) {
    if (n < 2) return 1;
    var MAX_PER_ROW = 6;
    var rows = Math.ceil(n / MAX_PER_ROW);
    return Math.ceil(n / rows);
  }

  function variantIdOf(label) {
    var m = /^swatch-detail-([0-9]+)-/.exec(label.getAttribute('for') || '');
    return m ? m[1] : null;
  }

  var bar = null;

  function build() {
    var labels = realSwatches();
    if (!labels.length || !realAdd()) return false;

    injectCss();

    bar = document.createElement('div');
    bar.className = 'lunelle-satc';
    bar.setAttribute('data-lunelle-satc', '');

    /* Bloc identite, rendu pour tout le monde mais visible seulement >= 750px.
       Le nom vient du h1 et le bloc prix/badges est CLONE de .lunelle-offer__row
       (le meme que sous le prix de la fiche), donc aucune copie a maintenir en
       double : si la promo change, la barre suit toute seule. Les deux sont
       facultatifs, la barre se construit meme si l'un manque. */
    var id = document.createElement('div');
    id.className = 'lunelle-satc__id';
    id.innerHTML =
      '<div class="lunelle-satc__thumb" data-satc-thumb aria-hidden="true"></div>' +
      '<div class="lunelle-satc__meta">' +
      '<span class="lunelle-satc__name" data-satc-name></span>' +
      /* La classe lunelle-offer est INDISPENSABLE ici, en plus de la notre.
         Les pastilles ne portent pas leurs couleurs en dur : .lunelle-offer
         declare cinq variables CSS (--lunelle-badge-solid-bg #FFD25B, -ink,
         -outline-bg, -outline-ink, -outline-line) que .lunelle-offer__badge--*
         lit ensuite en var(). Hors de ce conteneur les variables ne resolvent
         pas et les pastilles sortaient en fond transparent, donc en texte nu :
         constate a l'ecran le 2026-08-14, le padding et le rayon passaient bien
         mais pas la couleur. */
      '<div class="lunelle-satc__offer lunelle-offer" data-satc-offer></div>' +
      '</div>';
    var h1 = document.querySelector('product-info h1.product__title, h1.product__title');
    var nameEl = id.querySelector('[data-satc-name]');
    if (h1 && nameEl) nameEl.textContent = h1.textContent.trim();
    var offerRow = document.querySelector('.lunelle-offer__row');
    var offerSlot = id.querySelector('[data-satc-offer]');
    if (offerRow && offerSlot) offerSlot.appendChild(offerRow.cloneNode(true));

    var sw = document.createElement('div');
    sw.className = 'lunelle-satc__swatches';

    for (var i = 0; i < labels.length; i++) {
      var lab = labels[i];
      var vid = variantIdOf(lab);
      if (!vid) continue;

      /* Globo MASQUE les couleurs en rupture (li.globo-out-of-stock, display
         none) : elles n'apparaissent pas du tout dans le selecteur principal.
         Verifie le 2026-08-14 : Damier Lavande et Camel sont dans le DOM mais
         invisibles, et sans image de fond. Les reprendre donnait deux pastilles
         blanches vides dans la barre. On les saute donc, pour coller exactement
         a ce que la cliente voit plus haut : 11 couleurs, pas 13. */
      var li = lab.closest('li');
      if (li && (li.className.indexOf('globo-out-of-stock') !== -1 || getComputedStyle(li).display === 'none')) continue;

      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'lunelle-satc__sw';
      dot.setAttribute('data-satc-variant', vid);
      dot.title = lab.textContent.trim();
      dot.setAttribute('aria-label', lab.textContent.trim());
      /* Le visuel vient du style calcule : c'est globo qui le pose en inline. */
      var bg = getComputedStyle(lab).backgroundImage;
      if (bg && bg !== 'none') dot.style.backgroundImage = bg;
      if (li && li.className.indexOf('available') === -1) dot.classList.add('is-out');
      sw.appendChild(dot);
    }

    sw.style.setProperty('--per-row', perRow(sw.children.length));

    var buy = document.createElement('div');
    buy.className = 'lunelle-satc__buy';

    if (realQtyInput()) {
      var q = document.createElement('div');
      q.className = 'lunelle-satc__qty';
      q.innerHTML =
        '<button type="button" class="lunelle-satc__qbtn" data-satc-qty="minus" aria-label="Reduire la quantite">-</button>' +
        '<span class="lunelle-satc__qval" data-satc-qval>1</span>' +
        '<button type="button" class="lunelle-satc__qbtn" data-satc-qty="plus" aria-label="Augmenter la quantite">+</button>';
      buy.appendChild(q);
    }

    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'lunelle-satc__add';
    add.setAttribute('data-satc-add', '');
    add.textContent = 'Ajouter au panier';
    buy.appendChild(add);

    bar.appendChild(id);
    bar.appendChild(sw);
    bar.appendChild(buy);
    document.body.appendChild(bar);
    sync();
    return true;
  }

  /* --- miroir de l'etat reel -------------------------------------------- */
  function sync() {
    if (!bar) return;
    var checked = document.querySelector('input[id^="swatch-detail-"]:checked');
    var activeId = checked ? (/^swatch-detail-([0-9]+)-/.exec(checked.id) || [])[1] : null;
    var dots = bar.querySelectorAll('[data-satc-variant]');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', dots[i].getAttribute('data-satc-variant') === activeId);
    }

    /* La vignette desktop suit la couleur choisie. On reprend l'image de la
       pastille active plutot que la galerie : c'est la meme source que les
       pastilles, donc toujours coherent, et c'est deja resolu au moment ou on
       passe ici. */
    var thumb = bar.querySelector('[data-satc-thumb]');
    if (thumb) {
      var activeDot = bar.querySelector('[data-satc-variant].is-active') || dots[0];
      if (activeDot && activeDot.style.backgroundImage) thumb.style.backgroundImage = activeDot.style.backgroundImage;
    }

    var qi = realQtyInput();
    var qv = bar.querySelector('[data-satc-qval]');
    if (qi && qv) qv.textContent = qi.value || '1';
    var minus = bar.querySelector('[data-satc-qty="minus"]');
    var realMinus = realQtyBtn('minus');
    if (minus && realMinus) minus.disabled = realMinus.disabled || realMinus.classList.contains('disabled');

    var ra = realAdd();
    var add = bar.querySelector('[data-satc-add]');
    if (ra && add) {
      add.disabled = !!ra.disabled;
      var t = ra.textContent.trim();
      if (t) add.textContent = t;
    }
  }

  /* --- affichage / masquage, regle de Foldie ---------------------------- */
  var shown = false;

  /* Le marqueur d'ouverture du tiroir est la classe .active, PAS la visibilite.
     Mesure du 2026-08-14 : a l'ouverture les classes passent de
     "drawer false" a "drawer false animate active" et reviennent a la
     fermeture, tandis que la visibilite calculee reste "hidden" en permanence,
     y compris avec un visibility:visible !important en ligne (une animation CSS
     reprend la main). Se fier a la visibilite ne masquait donc jamais la barre. */
  function overlayOpen() {
    var d = document.querySelector('cart-drawer');
    if (d && (d.classList.contains('active') || getComputedStyle(d).visibility !== 'hidden')) return true;
    var p = document.querySelector('[data-gtl-panel]');
    if (p) { var r = p.getBoundingClientRect(); if (r.width > 2 && r.height > 2) return true; }
    return false;
  }

  function evaluate() {
    if (!bar) return;
    var anchor = anchorEl();
    if (!anchor) return;

    var footer = document.querySelector('footer');
    var rect = anchor.getBoundingClientRect();
    var vh = window.innerHeight;
    var want;

    if (overlayOpen()) {
      want = false;
    } else if (footer && footer.getBoundingClientRect().top < vh - FOOTER_MARGIN) {
      want = false;                                   /* pied de page en vue */
    } else if (rect.bottom <= 0) {
      want = true;                                    /* bouton passe au-dessus */
    } else if (rect.top < vh && rect.bottom > 0) {
      want = false;                                   /* bouton de nouveau visible */
    } else {
      want = shown;
    }

    if (want === shown) return;
    shown = want;
    bar.classList.toggle('is-shown', shown);
    document.documentElement.classList.toggle('lunelle-satc-active', shown);
  }

  /* rAF : evaluate() lit des rectangles, donc force un calcul de mise en page.
     Sans regroupement, un defilement au doigt en declencherait des centaines.
     Voir les regles anti-gel du projet. */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; evaluate(); });
  }

  /* --- proxys ------------------------------------------------------------ */
  function wire() {
    bar.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-satc-variant]');
      if (dot) {
        if (dot.classList.contains('is-out')) return;
        var vid = dot.getAttribute('data-satc-variant');
        var lab = document.querySelector('label.swatch-anchor[for^="swatch-detail-' + vid + '-"]');
        if (lab) lab.click();                       /* globo + theme font le reste */
        setTimeout(sync, 60);
        return;
      }
      var q = e.target.closest('[data-satc-qty]');
      if (q) {
        var b = realQtyBtn(q.getAttribute('data-satc-qty'));
        if (b) b.click();
        setTimeout(sync, 60);
        return;
      }
      if (e.target.closest('[data-satc-add]')) {
        var ra = realAdd();
        if (ra && !ra.disabled) ra.click();          /* voie native : tiroir + Kaching */
      }
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    /* Le theme re-rend la fiche au changement de variante : on resynchronise.
       childList seulement, jamais characterData (regles anti-gel). */
    var info = document.querySelector('product-info');
    if (info && window.MutationObserver) {
      new MutationObserver(function () { sync(); evaluate(); }).observe(info, { childList: true, subtree: true });
    }

    /* Ouvrir le tiroir ne provoque aucun defilement : sans cet observateur, la
       barre resterait affichee derriere lui. On surveille UNIQUEMENT l'attribut
       class du tiroir et du panneau, jamais characterData (regles anti-gel) :
       quelques mutations par ouverture, et evaluate() sort tout de suite si
       l'etat n'a pas change. */
    if (window.MutationObserver) {
      ['cart-drawer', '[data-gtl-panel]'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (el) new MutationObserver(function () { evaluate(); })
          .observe(el, { attributes: true, attributeFilter: ['class', 'style'] });
      });
    }

    document.addEventListener('lunelle:bogo:claimed', sync);
  }

  function boot() {
    if (bar) return true;
    if (!build()) return false;
    wire();
    evaluate();
    return true;
  }

  /* L'appli globo injecte les pastilles de couleur APRES le chargement : au
     moment du DOMContentLoaded elles n'existent pas encore. Mesure le
     2026-08-14 : 0 pastille au boot, 13 une fois la page en readyState
     complete, et la barre ne se construisait donc jamais. D'ou ce court
     reessai, borne a 20 s. */
  var tries = 0;
  var timer = setInterval(function () {
    if (boot() || ++tries > 80) clearInterval(timer);
  }, 250);

  /* Crochet de mise au point. onScroll() est regroupe par requestAnimationFrame,
     ce qui rend la regle d'affichage impossible a exercer dans un onglet non
     visible (rAF n'y tourne jamais). Ceci permet de la declencher a la main,
     depuis la console, ici comme sur un vrai telephone :
       lunelleStickyAtc.evaluate()   -> reevalue afficher / masquer
       lunelleStickyAtc.sync()       -> resynchronise pastille active et libelle
       lunelleStickyAtc.el()         -> la barre elle-meme */
  window.lunelleStickyAtc = {
    evaluate: function () { evaluate(); return shown; },
    sync: sync,
    el: function () { return bar; }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
